import { Link } from "react-router-dom";
import { blogPosts } from "../data/blogPosts";
import Header from "../components/Header";

export default function Blog() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 pt-[100px]">
      <Header />

      {/* --- Hero Header --- */}
      <header className="relative bg-gradient-to-r from-brandBlue to-brandPink text-white text-center py-24 px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-extrabold mb-5 leading-tight">
            Travel Smarter, Pack Lighter
          </h1>
          <p className="text-lg md:text-xl text-white/90">
            Explore travel guides, packing tips, and destination inspiration — all designed to help you travel effortlessly.
          </p>
        </div>
      </header>

      {/* --- Blog Grid --- */}
      <main className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {[...blogPosts]
            .sort((a, b) => new Date(b.date) - new Date(a.date)) // ✅ Sort newest first
            .map((post) => (
              <article
                key={post.slug}
                className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden flex flex-col"
              >
                {/* Thumbnail */}
                {post.image ? (
                  <img
                    src={post.image}
                    alt={post.alt || post.title}
                    className="h-48 w-full object-cover"
                  />
                ) : (
                  <div className="h-48 w-full bg-gray-200 flex items-center justify-center text-gray-400">
                    No Image
                  </div>
                )}

                {/* Post content */}
                <div className="p-6 flex flex-col flex-grow">
                  <h2 className="text-xl font-bold text-gray-900 mb-2 hover:text-brandBlue transition-colors">
                    {post.title}
                  </h2>
                  <p className="text-sm text-gray-500 mb-3">{post.date}</p>
                  <p className="text-gray-700 mb-6 line-clamp-3 flex-grow">
                    {post.summary}
                  </p>
                  <Link
                    to={`/blog/${post.slug}`}
                    className="mt-auto inline-block bg-brandBlue text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-brandPink transition-colors"
                  >
                    Read More →
                  </Link>
                </div>
              </article>
            ))}
        </div>
      </main>

      {/* --- Footer --- */}
      <footer className="bg-gray-100 border-t py-10 text-center text-gray-500 text-sm">
        <p>
          © {new Date().getFullYear()} SmartPackr — Simplify your journey, pack smarter.
        </p>
      </footer>
    </div>
  );
}
